import { vShow as _vShow, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/logo/logo.png';
const _hoisted_1 = {
  class: "sidenav-header-override pt-4 d-flex p-1"
};
const _hoisted_2 = ["alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_SideNavList = _resolveComponent("SideNavList");
  return _openBlock(), _createElementBlock(_Fragment, null, [_withDirectives(_createElementVNode("div", {
    class: "min-height-300 position-absolute w-100",
    style: _normalizeStyle(`background-color:${$options.mainColor}`)
  }, null, 4), [[_vShow, $data.layout === 'default']]), _createElementVNode("aside", {
    id: "sidenav-main",
    class: _normalizeClass(["sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 ms-4", ` ${$data.sidebarType} ${$data.isRTL ? 'fixed-end me-3 rotate-caret' : 'fixed-start ms-3'} ${$data.layout === 'landing' ? 'bg-transparent shadow-none' : ''}`])
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_router_link, {
    to: $options.mainPath,
    tag: "div",
    style: {
      "margin": "0 auto",
      "display": "inline-block"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      src: _imports_0,
      alt: $options.projectName,
      style: {
        "object-fit": "contain",
        "margin": "0 auto"
      },
      id: "logo_img"
    }, null, 8, _hoisted_2)]),
    _: 1
  }, 8, ["to"])]), _cache[0] || (_cache[0] = _createElementVNode("hr", {
    class: "mt-0 horizontal dark"
  }, null, -1)), _createVNode(_component_SideNavList)], 2)], 64);
}